import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { ValidarSesion } from "../shared/Validaciones";
import { ValidarLtr, ValidarNum, ValidarNumLtr } from "../shared/Regex";
import Menu from "./components/Menu";
import Aviso, { mostrarAviso } from "./components/Aviso";
import { dB64 } from "../shared/Encriptacion";
import { HEADERS_API } from "./NuevaGuia";
import axios from "axios";


export default function DetalleUsuario(){
    // ======================================================================================================
    //#region HOOKS STATE
    // ======================================================================================================
    // ESTADOS DE ACTUALIZACIÓN
    const[nuevoNombre, setNuevoNombre] = useState("");
    const[nuevoCodigo, setNuevoCodigo] = useState("");
    const[nuevoRol, setNuevoRol] = useState(0);
    const[nuevoEstado, setNuevoEstado] = useState(false);
    const[nuevoNickname, setNuevoNickname] = useState("");
    const[nuevaClave, setNuevaClave] = useState("");
    const[fechaCreacion, setFechaCreacion] = useState("");
    const[fechaModificacion, setFechaModificacion] = useState("");

    // ESTADOS DE VALIDACIÓN
    const[claveConfirmacion, setClaveConfirmacion] = useState("");
    const[datosCompletos, setDatosCompletos] = useState(false);
    const[mostrarClave, setMostrarClave] = useState(false);

    // ESTADOS DE CONTENIDO
    const[selectRol, setSelectRol] = useState(<></>);

    //#endregion

    // ======================================================================================================
    //#region HOOKS EFFECT
    // ======================================================================================================
    
    useEffect(()=>{
        ValidarSesion();
        ObtenerRolesUsuario();
        ObtenerDatosUsuario();
    },[]);

    // VALIDACIÓN DE DATOS COMPLETOS
    useEffect(()=>{
        try{
            if(nuevoNombre == "" || nuevoCodigo == "" || nuevoRol == 0 || nuevoNickname == ""){
                throw new Error();
            }

            if(nuevaClave != claveConfirmacion){
                throw new Error();
            }

            HandlerDatosCompletos(false);
        }catch(error){
            HandlerDatosCompletos(true);
        }
    },[nuevoNombre, nuevoCodigo, nuevoRol, nuevoNickname, nuevaClave, claveConfirmacion]);

    //#endregion

    // ======================================================================================================
    //#region  HOOK NAVIGATE PARAMS
    // ======================================================================================================
    const navigate = useNavigate();
    const{codUsuarioActualizar} = useParams();
    //#endregion
    

    // ======================================================================================================
    //#region HANDLERS
    // ======================================================================================================
    // ESTADOS DE ACTUALIZACIÓN
    const HandlerNuevoNombre = (valor) => {
        if(ValidarLtr(valor) || valor == ""){
            setNuevoNombre(valor.toUpperCase());
        }
    }
    const HandlerNuevoCodigo = (valor) => {
        if(ValidarNum(valor) || valor == ""){
            setNuevoCodigo(valor);
        }
    }
    const HandlerNuevoRol = (valor) => setNuevoRol(valor);
    const HandlerNuevoEstado = (valor) => setNuevoEstado(valor);
    const HandlerNuevoNickname = (valor) => {
        if(ValidarNumLtr(valor) || valor == ""){
            setNuevoNickname(valor);
        }
    }
    const HandlerNuevaClave = (valor) => {
        if(ValidarNum(valor) || valor == ""){
            setNuevaClave(valor);
        }
    };
    const HandlerFechaCreacion = (valor) => setFechaCreacion(valor);
    const HandlerFechaModificacion = (valor) => setFechaModificacion(valor);

    // ESTADOS DE VALIDACIÓN
    const HandlerClaveConfirmacion = (valor) => {
        if(ValidarNum(valor) || valor == ""){
            setClaveConfirmacion(valor);
        }
    }
    const HandlerDatosCompletos = (valor) => setDatosCompletos(valor);
    const HandlerMostrarClave = () => {
        if(mostrarClave){
            setMostrarClave(false);
        }else{
            setMostrarClave(true);
        }
    }
    
    //ESTADOS DE CONTENIDO
    const HandlerSelectRol = (lista) => {
        const listaRoles = [
            { id: "0", descripcion: "Seleccionar" },
            ...lista.map(rol => ({ id: rol.id, descripcion: rol.descripcion }))
        ];

        const listaOpciones = listaRoles.map(item => (
            <option key={item.id} value={item.id} className="text-capitalize">
                {item.descripcion.toLowerCase()}
            </option>
        ));

        setSelectRol(listaOpciones);
    }

    //#endregion

    // ======================================================================================================
    //#region FUNCIONES
    // ======================================================================================================
    // FUNCIONES ASÍNCRONAS
    const ObtenerRolesUsuario = async () => {
        try{
            let response = await axios.get(URL_ROLES_USUARIO,{
                headers: HEADERS_API
            }).catch(error => {
                throw new Error(error.message);
            });

            HandlerSelectRol(response.data.lista);
        }catch(error){
            console.log(error);
        }
    }
    const ObtenerDatosUsuario = async () => {
        try{
            const response = await axios.get(URL_DATOS_USUARIO,{
                headers: HEADERS_API,
                params: {
                    codigoConsultar: codUsuarioActualizar
                }
            }).catch(error => {
                throw new Error(error.message);
            });

            const datos = response.data;

            if(datos["codigo"] == null){
                throw new Error("El usuario no existe");
            }

            HandlerNuevoCodigo(datos["codigo"]);
            HandlerNuevoRol(datos["codigoRol"]);
            if(datos["estado"] == 'activo'){
                HandlerNuevoEstado(true);
            }else{
                HandlerNuevoEstado(false);
            }
            HandlerFechaCreacion(datos["fechaCreacion"]);
            HandlerFechaModificacion(datos["fechaModificacion"]);
            HandlerNuevoNickname(datos["nickname"]);
            HandlerNuevoNombre(datos["nombre"]);
        }catch(error){
            console.log(error);
            navigate("/usuarios");
        }
    }
    const ActualizarDatosUsuario = async () => {
        let paramClave = nuevaClave == "" ? "-" : nuevaClave; 
        try{
            let response = await axios.put(URL_EDITAR_USUARIO, {
                codigoUsuarioEditar: codUsuarioActualizar,
                nombre: nuevoNombre,
                codigo: nuevoCodigo,
                rol: nuevoRol,
                estado: nuevoEstado,
                nickname: nuevoNickname,
                clave: paramClave
            }, {
                headers: HEADERS_API
            }).catch(error => {
                throw new Error(error.response.data);
            });

            navigate("/usuarios");
        }catch(error){
            mostrarAviso(error, 2500);
        }
    }

    //#endregion

    // ======================================================================================================
    //#region CONTENIDO
    // ======================================================================================================
    return(<>
    <Menu/>
    <Aviso/>
    <div className="container">
        <div className="row">
            <div className="col-12 py-2 border-bottom border-secondary text-secondary text-center text-md-start">
                <h2>{dB64(localStorage.getItem('r6'))}</h2>
            </div>
            <div className='col-12 p-3 text-secondary'>
                <Link className='' to={'/usuarios'}>
                    <button className='btn btn-secondary'>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-return-left" 
                        viewBox="0 0 16 16">
                            <path fillRule="evenodd" d="M14.5 1.5a.5.5 0 0 1 .5.5v4.8a2.5 2.5 0 0 1-2.5 2.5H2.707l3.347 3.346a.5.5 0 0 1-.708.708l-4.2-4.2a.5.5 0 0 1 0-.708l4-4a.5.5 0 1 1 .708.708L2.707 8.3H12.5A1.5 1.5 0 0 0 14 6.8V2a.5.5 0 0 1 .5-.5"/>
                        </svg>
                        <span className='mx-2'>Regresar</span>
                    </button>
                </Link>
            </div>
            <div className='col-12 pb-2 fs-3 fw-semibold'>
                DETALLE DE USUARIO
            </div>
            <div className="col-12 pb-2 row">
                <div className="col-12 col-md-6">
                    <div className="col-12 py-2">
                        <span className="fw-bold mx-2">Creado: </span> {fechaCreacion}
                    </div>
                    <div className="col-12 pb-3">
                        <span className="fw-bold mx-2">Modificado: </span> {fechaModificacion}
                    </div>
                </div>
                <div className="col-12 col-md-6 px-4 d-flex align-items-center">
                    <div className="form-check form-switch fs-5">
                        <input onChange={e=>HandlerNuevoEstado(!nuevoEstado)} checked={nuevoEstado} className="form-check-input" type="checkbox" role="switch" id="estado-usuario"/>
                        <label className="form-check-label fw-semibold" htmlFor="estado-usuario">{nuevoEstado ? "Usuario Habilitado" : "Usuario Deshabilitado"}</label>
                    </div>
                </div>
            </div>
            <div className="col-12 col-md-6">
                <div className="p-1">
                    <label className="form-label fw-semibold text-uppercase" htmlFor="nombre-usuario">Nombre Completo</label>
                    <input onChange={e=>HandlerNuevoNombre(e.target.value)} value={nuevoNombre} maxLength={120} type="text" className="form-control" id="nombre-usuario" autoComplete="off" />
                </div>
                <div className="p-1">
                    <label className="form-label fw-semibold" htmlFor="codigo-usuario">N° Documento</label>
                    <input onChange={e=>HandlerNuevoCodigo(e.target.value)} value={nuevoCodigo} maxLength={11} type="text" className="form-control" id="codigo-usuario" autoComplete="off" />
                </div>
                <div className="p-1">
                    <label className="form-label fw-semibold" htmlFor="rol-usuario">Perfil</label>
                    <select onChange={e=>HandlerNuevoRol(e.target.value)} value={nuevoRol} id="rol-usuario" className="form-select text-capitalize">
                        {selectRol}
                    </select>
                </div>
            </div>
            <div className="col-12 col-md-6">
                <div className="p-1">
                    <label className="form-label fw-semibold" htmlFor="nickname-usuario">ID de Usuario</label>
                    <input onChange={e=>HandlerNuevoNickname(e.target.value)} value={nuevoNickname} maxLength={50} type="text" className="form-control" id="nickname-usuario" autoComplete="off" />
                </div>
                <div className="p-1">
                    <label className="form-label fw-semibold" htmlFor="clave-usuario">Nueva Contraseña</label>
                    <div className="form-text">Si no desea cambiar su contraseña, deje este campo en blanco</div>
                    <input onChange={e=>HandlerNuevaClave(e.target.value)} value={nuevaClave} maxLength={20} type={mostrarClave ? "text" : "password"} className="form-control" id="clave-usuario" />
                </div>
                <div className="p-1">
                    <label className="form-label fw-semibold" htmlFor="confirmar-clave-usuario">Confirmar Nueva Contraseña</label>
                    <input onChange={e=>HandlerClaveConfirmacion(e.target.value)} value={claveConfirmacion} maxLength={20} type={mostrarClave ? "text" : "password"} className="form-control" id="confirmar-clave-usuario" />
                </div>
                <div className="p-1 d-flex justify-content-end">
                    <div className="form-check">
                        <input onChange={HandlerMostrarClave} checked={mostrarClave} className="form-check-input" type="checkbox" id="mostrar-clave-nueva"/>
                        <label className="form-check-label" htmlFor="mostrar-clave-nueva">
                        Mostrar Contraseñas
                        </label>
                    </div>
                </div>
            </div>
            <div className="col-12 py-4 d-flex justify-content-center align-items-center">
                <button onClick={ActualizarDatosUsuario} disabled={datosCompletos} className="btn btn-primary">Guardar Cambios</button>
            </div>
        </div>
    </div>
    </>)

    //#endregion
}

// ======================================================================================================
//#region CONSTANTES
// ======================================================================================================
const URL_ROLES_USUARIO = process.env.REACT_APP_URL_ROLES_USUARIO;
const URL_DATOS_USUARIO = process.env.REACT_APP_URL_DATOS_USUARIO;
const URL_EDITAR_USUARIO = process.env.REACT_APP_URL_EDITAR_USUARIO;
//#endregion